import React from 'react';

import { LoaderSpinner } from './LoaderSpinner';

export const PageLoader = () => {
  return <LoaderSpinner />;
};
